import { createDivIn, createOptionIn, createParagraphIn, createSelectIn, setElementInnerHTML, setElementOnClick } from '../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { notificationController, socket } from '../../../../../shared/scripts/EntryShared.ts';
import { LobbyImage } from '@colonist/types';
export class UIRoomCenterSeedOrderSelectionController {
    updateSeedOrderSelection(roomState, footer, data) {
        this.roomState = roomState;
        this.seedOrderSelectionData = data;
        if (this.mainContainer != undefined) setElementInnerHTML(this.mainContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.mainContainer = createDivIn(this.parentContainer, 'seed_order_selection_container');
        const amIHost = this.roomState.hostSession.userSessionId == socket.controller.session.id;
        const seedOrderMap = new Map(data.seedOrder);
        for (const [index] of roomState.getSessions().entries()){
            var _roomState_getSessions_find;
            const seedOrder = index + 1;
            const sessionContainer = createDivIn(this.mainContainer, 'seed_order_selection_session_container');
            createParagraphIn(sessionContainer, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: `#${seedOrder}`
                }
            }, 'seed_order_selection_session_text');
            const playerNameSelector = createSelectIn(sessionContainer, '', '', (value)=>UIRoomCenterSeedOrderSelectionController.onSetSeedOrder(value, seedOrder, playerNameSelector));
            const defaultText = amIHost ? {
                key: 'strings:roomPage.orderSelection.seedOrderSelection.selectPlayer'
            } : {
                key: 'strings:roomPage.orderSelection.seedOrderSelection.waitingForHost'
            };
            createOptionIn(playerNameSelector, 'Select Player', defaultText, true);
            playerNameSelector.disabled = !amIHost;
            const bufferKey = 'strings:colonistCommon.utils.#buffer';
            for (const session of roomState.getSessions())createOptionIn(playerNameSelector, session.selectedColor.toLocaleString(), {
                key: bufferKey,
                options: {
                    value: `${session.username}`
                }
            });
            if (!seedOrderMap.has(seedOrder)) continue;
            const playerColor = (_roomState_getSessions_find = roomState.getSessions().find((session)=>session.selectedColor == seedOrderMap.get(seedOrder))) === null || _roomState_getSessions_find === void 0 ? void 0 : _roomState_getSessions_find.selectedColor.toLocaleString();
            playerNameSelector.value = playerColor !== null && playerColor !== void 0 ? playerColor : 'PlayerNotFound';
        }
        if (!amIHost) return;
        if (this.checkMarkButton != undefined) return;
        this.checkMarkButton = createDivIn(footer, 'btn_general btn_general_check');
        setElementOnClick(this.checkMarkButton, ()=>this.onConfirmSelection());
    }
    setFooterContentVisibility(visible) {
        if (this.checkMarkButton == undefined) return;
        this.checkMarkButton.hidden = !visible;
    }
    setScrollContainerContentVisibility(visible) {
        if (this.mainContainer == undefined) return;
        this.mainContainer.hidden = !visible;
    }
    static onSetSeedOrder(value, seedOrder, playerNameSelector) {
        const currentValue = parseInt(playerNameSelector.value, 10);
        if (isNaN(currentValue)) playerNameSelector.remove(playerNameSelector.selectedIndex);
        const playerColor = parseInt(value, 10);
        socket.roomClient.setSeedOrder(playerColor, seedOrder);
    }
    onConfirmSelection() {
        if (this.seedOrderSelectionData == undefined) return;
        if (this.seedOrderSelectionData.seedOrder.length != this.roomState.getSessionCount()) return notificationController.showNotification(LobbyImage.XMark, {
            key: 'strings:roomPage.notifications.assignAllPlayersToASeed'
        });
        const playerColors = this.seedOrderSelectionData.seedOrder.map((entry)=>entry[1]);
        const uniquePlayerColors = new Set(playerColors);
        if (uniquePlayerColors.size != playerColors.length) return notificationController.showNotification(LobbyImage.XMark, {
            key: 'strings:roomPage.notifications.cantAssignAPlayerToMultipleSeeds'
        });
        socket.roomClient.startPlayOrderSelection();
    }
    constructor(scrollContainer){
        this.parentContainer = scrollContainer;
    }
}
